import { render, staticRenderFns } from "./NovaCotacaoLocaisRecebimento.vue?vue&type=template&id=02da296c&scoped=true"
import script from "./NovaCotacaoLocaisRecebimento.vue?vue&type=script&setup=true&lang=js"
export * from "./NovaCotacaoLocaisRecebimento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NovaCotacaoLocaisRecebimento.vue?vue&type=style&index=0&id=02da296c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02da296c",
  null
  
)

export default component.exports